// extracted by mini-css-extract-plugin
export var slider = "Pricing-module--slider--1vV5T";
export var thumb = "Pricing-module--thumb--24Q9g";
export var track = "Pricing-module--track--22wLh";
export var track0 = "Pricing-module--track-0--3SkU6";
export var planText = "Pricing-module--planText--2LaV5";